module.exports = __webpack_public_path__ + "h5/img/summer-card.b46dab34.jpg";